export class HtmlElementTypes
{
    public static INPUT: string = "INPUT";
    public static BUTTON: string = "BUTTON";
}
